import React from 'react';

const Testimonail = ({testimonial}) => (
    <div className="testimonial">
        <img className="w-24 h-24 mx-auto mb-12 rounded-full" src={ testimonial.image.fluid.src } alt="Face" />
        <em className="italic text-lg inline-block mb-4">{ testimonial.comment }</em>
        <h4 className="font-primary uppercase text-base font-bold mb-2">- { testimonial.name }</h4>
        <p className="text-sm text-gray-200">{ testimonial.company }</p>
    </div>
);

export default Testimonail;